import type { ProblemPayload } from "../../../api/threads/liveMessages";

/** Why the host's agent can't run on its PC now, where the fix is on that PC (connector.md CP-11). */
export interface RouteNotReadyProblem {
  readonly reason: "not_logged_in" | "not_installed";
  readonly agentId: string;
  /** The connector of the PC it happened on, which may no longer host the Thread. */
  readonly connectorId: string;
}

/** A problem module C records when the Thread's agent isn't signed in or installed on the host's PC (CW-1); else `null`. */
export function routeNotReadyOf(problem: ProblemPayload["problem"]): RouteNotReadyProblem | null {
  if (problem.code !== "capability_mismatch") return null;
  const missing: unknown = problem.details["missing"];
  const agentId: unknown = problem.details["agent_id"];
  const connectorId: unknown = problem.details["connector_id"];
  const reason: unknown = Array.isArray(missing) ? (missing as unknown[])[0] : undefined;
  return (reason === "not_logged_in" || reason === "not_installed") && typeof agentId === "string" && typeof connectorId === "string" ? { reason, agentId, connectorId } : null;
}
